(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('EventFormDeleteController',EventFormDeleteController);

    EventFormDeleteController.$inject = ['$uibModalInstance', 'entity', 'EventForm'];

    function EventFormDeleteController($uibModalInstance, entity, EventForm) {
        var vm = this;
        vm.eventForm = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            EventForm.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
